import { Fragment, useMemo } from 'react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import * as styles from './Avis.css';
import TrustPilotLogo from './TrustPilotLogo';

const Avis = () => {
  const slides = useMemo(() => shuffleArray(avis), []);

  return (
    <Swiper
      className={styles.swiper}
      pagination={{ clickable: true }}
      modules={[Pagination]}
      loop={true}
      autoHeight={true}
    >
      {slides.map((slide, index) => (
        <SwiperSlide className={styles.slide} key={index}>
          <div className={styles.content}>
            <p className={styles.title}>{slide.title}</p>
            <p>
              {slide.description.map((line, lineIndex) => (
                <Fragment key={lineIndex}>
                  {lineIndex > 0 && <br />}
                  {line}
                </Fragment>
              ))}
            </p>
            <div className={styles.rating}>
              <p className={styles.name}>{slide.name}</p>
              <TrustPilotLogo />
              <span className={styles.stars}>★★★★★</span>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

const avis = [
  {
    name: 'Tiphaine A.',
    title: "Excellence académique et liberté d'organisation",
    description: [
      "Un enseignement très agréable qui m'a offert :",
      "Un enseignement de qualité et complet, des modules et moyens d'apprendre adaptés, une information claire et suffisamment détaillée, une grande liberté, une nécessité d'apprendre la discipline pour tout valider, un service apprenant réactif par mail.",
      'Merci à vous et si besoin, je reviendrai apprendre de nouveau avec vous ! 😀',
    ],
  },
  {
    name: 'Livia',
    title: 'Le tremplin idéal pour mon projet ',
    description: [
      'Une formation très enrichissante et constructive dans la réalisation de mon projet entrepreneurial. Les modules sont clairs et complets. Le suivi est très bien géré avec des coachs et mentors toujours à l’écoute.',
    ],
  },
  {
    name: 'Alain B.',
    title: 'Un suivi parfait dès le premier jour',
    description: [
      'Dès le début de la formation, le programme des cours m’a très bien été expliqué, ma coach qui m’accompagne répond parfaitement à mes interrogations. Le suivi est parfait.',
      'Le contenu est clair, pertinent et conforme à mes attentes.',
      'Je recommande !',
    ],
  },
  {
    name: 'Sabine B.',
    title: 'Apprendre à son rythme, sans stress',
    description: [
      "Tentez l'expérience vous ne le regretterez pas C'est une super expérience que je recommande grandement. Je peux réviser et travailler à la maison et à mon rythme.",
      "Si je ne suis pas contente de mes résultats, je peux refaire la série autant de fois que je veux et du coup m'améliorer.Le suivi est top également.",
    ],
  },
  {
    name: 'Merle',
    title: 'Un accompagnement humain exemplaire',
    description: [
      "Je recommande L'École Française pour la qualité de formation que j'ai reçue. L'espace élève est très bien structuré, les cours sont détaillés. Un grand merci à ma coach, les mentors et les professeurs pour cet accompagnement!",
    ],
  },
];

const shuffleArray = <T,>(elements: T[]): T[] => {
  const result = [...elements];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
};

export default Avis;
